export const applyDiscountPolicy = (discount_rate: number) => {
  if (discount_rate >= 100) {
    return 100;
  } else if (discount_rate < 100 && discount_rate >= 99) {
    return 99;
  } else if (discount_rate < 99 && discount_rate >= 1) {
    return Math.round(discount_rate);
  } else {
    return 0;
  }
};
